<template>
  <div class="Brunch-insert">
    <ux-atoms-typo as="h3" class="Brunch-insert__title"> {{ title }} </ux-atoms-typo>
    <ul class="Brunch-insert__features" v-if="Array.isArray(brunchFeatures) && brunchFeatures.length > 0">
      <li :key="feature" class="Brunch-insert__features--item" v-for="feature in brunchFeatures">
        {{ $t('pages.restaurant.brunchInsert.brunchFeatures.' + feature) }}
      </li>
    </ul>
    <div class="Brunch-insert__opening-hours">
      <ux-atoms-typo as="p" class="Brunch-insert__opening-hours--hour">{{
        $t('pages.restaurant.brunchInsert.period', { from: period.from, to: period.to })
      }}</ux-atoms-typo>
      <ux-atoms-typo as="p" class="Brunch-insert__opening-hours--day">{{ computedDays }}</ux-atoms-typo>
    </div>
    <ux-atoms-typo as="p" class="Brunch-insert__description">{{ description }}</ux-atoms-typo>
  </div>
</template>

<script lang="ts" setup>
interface BrunchInsertPeriod {
  from: string;
  to: string;
}

interface BrunchInsertProps {
  brunchFeatures: string[];
  days: string[];
  description: string;
  period: BrunchInsertPeriod;
  title: string;
}

const props = defineProps<BrunchInsertProps>();

const { t } = useI18n();

const computedDays = computed(() => {
  if (props.days.length === 1) {
    return t('pages.restaurant.brunchInsert.days', { days: t('days.' + props.days[0].toLowerCase()) });
  }

  return t('pages.restaurant.brunchInsert.days', { days: props.days.map((day) => t('days.' + day.toLowerCase())).join(', ') });
});
</script>

<style lang="scss" scoped>
@use 'BrunchInsert.scss';
</style>
